<button
  type="button"
  mat-icon-button
  (click)="toggle($event)">
  <mat-icon>{{ (favorites | checkFavorites: modelName : modelId) ? 'favorite' : 'favorite_border' }}</mat-icon>
</button>
